import styled from 'styled-components';
import { body2, colors, fontWeights } from 'ui/theme';
import { Banner } from 'ui/banner';

export const StyledBanner = styled(Banner)`
  width: 100%;
`;

export const WarningIcon = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
`;

export const ErrorText = styled.div`
  ${body2}
  color: ${colors.textDestructive};
`;

export const WarningText = styled.div`
  ${body2}
  color: ${colors.textWarning};
  font-weight: ${fontWeights.bold};
`;

export const WarningSubtext = styled.div`
  ${body2}
  color: ${colors.textWarning};
`;

export const DescriptionText = styled.div`
  ${body2}
  color: ${colors.textPrimary};
`;

export const DescriptionSubtext = styled.div`
  ${body2}
  color: ${colors.textPrimary};
  font-weight: ${fontWeights.bold};
`;
